import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./vee-validation";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./axios";
import "./errorHandling";
import "../public/style/feuerring.css";
import store from "./store";
import { AuthState } from "@/store/auth.store";
Vue.config.productionTip = false;

if (window.sessionStorage.getItem("user")) {
  const cookiedState: AuthState = JSON.parse(
    window.sessionStorage.getItem("user") ?? ""
  );
  if (cookiedState) {
    store.commit("auth/successCurrentUser", cookiedState.currentUser);
  }
}


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");